export default __webpack_public_path__ + "static/media/Tiger_Global2.886dfb59.png";